import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';


export const BrandsPage = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number],
    },

    methods: {
        filterBrands(e){
            let btn = $(e.target);

            if(btn.hasClass('is-active')){
                $('.js-brands-block').removeClass('is-hide');
                $('.js-brands-filter-letter').removeClass('is-active');
            }else{
                $('.js-brands-block').addClass('is-hide');
                $('.js-brands-filter-letter').removeClass('is-active');
                btn.addClass('is-active');
                $('.js-brands-block[data-letter="' + btn.data('letter') + '"]').removeClass('is-hide');
            }

        },
        showAll(){
            $('.js-brands-block').removeClass('is-hide');
            $('.js-brands-filter-letter').removeClass('is-active');
        }
    },
    updated(){

    },
    mounted(){

    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH'])
    },
    template: `
<section v-if="this.struct[this.structKey].componentData.ITEMS" class="section section--first">
    <div class="container">
        <div class="brands__filter-wp">
            <div class="brands__filter">
                <a href="#" class="brands__filter-btn js-show-all-brands" @click.prevent="showAll()">
                    Все
                </a>
                <div class="brands__filter-lins">
                    <div class="brands__filter-line">

                        <a v-for="(items, letter) in this.struct[this.structKey].componentData.ITEMS.EN"
                            href="#"
                            class="brands__filter-line-item js-brands-filter-letter"
                            @click.prevent="filterBrands($event)"
                            :data-letter="letter"
                            :class="{'disable': !items.length}"
                            >
                            {{letter}}
                        </a>

                    </div>
                    <div class="brands__filter-line">

                        <a v-for="(items, letter) in this.struct[this.structKey].componentData.ITEMS.RU"
                            href="#"
                            class="brands__filter-line-item js-brands-filter-letter"
                            @click.prevent="filterBrands($event)"
                            :data-letter="letter"
                            :class="{'disable': !items.length}"
                            >
                            {{letter}}
                        </a>

                    </div>
                </div>
            </div>
            <div class="brands__blocks">

                <template v-for="(items, letter) in this.struct[this.structKey].componentData.ITEMS.EN">
                    <div v-if="items.length" class="brands__blocks-item js-brands-block" :data-letter="letter">
                        <div class="brands__blocks-item-title">{{letter}}</div>
                        <div class="brands__blocks-item-list">

                            <a v-for="item in items" :href="item.LINK" class="brands__blocks-item-list-link">
                                <div class="brands__blocks-item-list-link-logo" :class="{'no-photo': item.IMAGE.IMAGE === false}">
                                     <img v-if="item.IMAGE.IMAGE !== false" class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="item.IMAGE.IMAGE" :alt="item.NAME" :title="item.NAME">
                                    <img v-else :src="this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" :alt="item.NAME" :title="item.NAME" loading="lazy">
                                </div>
                                <div class="brands__blocks-item-list-link-name">{{item.NAME}}</div>
                            </a>

                        </div>
                    </div>
                </template>

                <template v-for="(items, letter) in this.struct[this.structKey].componentData.ITEMS.RU">
                    <div v-if="items.length" class="brands__blocks-item js-brands-block" :data-letter="letter">
                        <div class="brands__blocks-item-title">{{letter}}</div>
                        <div class="brands__blocks-item-list">

                            <a v-for="item in items" :href="item.LINK" class="brands__blocks-item-list-link">
                                <div class="brands__blocks-item-list-link-logo" :class="{'no-photo': item.IMAGE.IMAGE === false}">
                                    <img v-if="item.IMAGE.IMAGE !== false" class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="item.IMAGE.IMAGE" :alt="item.NAME" :title="item.NAME">
                                    <img v-else :src="this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" :alt="item.NAME" :title="item.NAME" loading="lazy">
                                </div>
                                <div class="brands__blocks-item-list-link-name">{{item.NAME}}</div>
                            </a>

                        </div>
                    </div>
                </template>


            </div>
        </div>
    </div>
</section>
    `
}